<template>
  <div class="header">
    <div class="logo-container">
      <h1>
        <div class="header-logo">U+</div>
        <div>온라인 가입신청</div>
      </h1>
    </div>
  </div>
</template>

<script>
export default {
  name: 'OnsaleHomeHeader',

  computed: {
    environment() {
      return process.env.VUE_APP_ENV
    }
  },

  methods: {
    
  }
}
</script>

<style scoped></style>
